<mds-layout-loading-indicator />
<mds-layout-shell #shell>
  <mds-layout-header mdsLayoutHeader>
    <ng-container mdsLayoutHeaderLeft>
      <div class="flex flex-row gap-2">
        <button
          mat-icon-button
          class="border-0 focus:outline-none"
          (click)="shell.isNavOpenToggle()"
          mdsQaId="toggle-menu-btn"
        >
          <mat-icon>menu</mat-icon>
        </button>
        <a class="flex items-center" [mdsTenantLink]="RplRoutes.Home()">
          <img
            src="https://assets.app.planzer.ch/image/brands/planzer.svg"
            class="flex cursor-pointer"
            alt="Planzer Logo"
          />
        </a>
      </div>
    </ng-container>

    <mds-header-menu mdsLayoutHeaderRight></mds-header-menu>
  </mds-layout-header>

  <div class="h-full">
    <router-outlet></router-outlet>
  </div>
</mds-layout-shell>
